<template>
  <SPSliderSection
    class="popular-schools-section"
    :title="title"
    :loading="loading"
    :data="schools"
    :class="ui?.root"
    :all-button="ALL_BUTTON"
    mobile-all-button
  >
    <template #default="{ slide }">
      <CommonCard
        :item="slide"
        hover
        :to="`/schools/${slide.id}`"
        image-top-left="lesson-types"
        image-top-right="rating"
        title-above-left="directions"
        :title-above-right="getLabelIcons(slide)"
        footer
        :ui="{
          title: 'max-sm:line-clamp-2',
        }"
        @register="openSignForClassModal($event)"
        @detail="$router.push(`/schools/${$event}`)"
      />
    </template>
  </SPSliderSection>
</template>

<script lang="ts" setup>
import type { School } from '~/api'
import SignForClassModal from '../SignForClassModal.vue'
import { useModal } from '~/shared/modals'
import type { IconWithLabel } from '~/types'

defineOptions({
  name: 'PopularSchoolsSection',
})

const props = withDefaults(
  defineProps<{
    schools?: School[]
    title?: string
    loading?: boolean
    ui?: {
      root?: string
      title?: string
      image?: string
    }
  }>(),
  {
    title: 'Популярные школы',
  },
)

const ALL_BUTTON = {
  label: 'Все школы',
  to: '/schools',
}

const pageStore = usePageStore()
const { mainPage } = storeToRefs(pageStore)
const schools = computed(() => (props.schools || mainPage.value?.schools) ?? [])

const getLabelIcons = (item: School): IconWithLabel[] => [
  {
    icon: 'i-local-coach',
    label: 'Тренеры',
    value: item.trainers_count,
    to: `/schools/${item.id}/trainers`,
  },
]

const openSignForClassModal = (id: string) => {
  const { open } = useModal(SignForClassModal, {
    props: {
      id,
      apiMethod: useSchoolStore().trainingSignup,
    },
  })
  open()
}
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 514px;
  --card-image-height: 374px;
  --card-hover-image-height: 250px;

  @include max-xl {
    --card-height: 394px;
    --card-image-height: 180px;
  }

  @include max-md {
    --card-height: 310px;
    --card-image-height: 140px;
  }
}
</style>
